import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

var Config = require('../../../config');

class ModalUpdateRh extends Component{
	constructor(props){
		super(props);
	
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.updateGroupRh = this.updateGroupRh.bind(this);

		this.state = {
			show: false,
			person_id:"",
			person_group:"",
			person_rh:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'person/get_group_rh?person_id='+id, {
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				var rh_group = response.lookup_rh === '' || response.lookup_rh === null ? 
									response.lookup_group 
								: response.lookup_rh === 'POSITIVO' ?
									response.lookup_group+'+'
								: response.lookup_group+'-'
							

				this.setState({
					show: true,
					person_id:id,
					person_group:response.lookup_group,
					person_rh: response.lookup_rh === 'POSITIVO' ? '+' : '-'
				});
			}
		})
				
	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	updateGroupRh(){
		this.props.waiting.handleShow('Actualizando..');
		var rh = this.state.person_rh === '+' ? 'POSITIVO' : 'NEGATIVO';

		fetch(Config.default.apiGateway.URL+'person/update_group_rh?person_id='+this.state.person_id+
				'&group='+this.state.person_group+'&rh='+rh+'&sample='+this.props.sample, {
			method: 'put',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.props.getData('update');
				if(this.props.donor !== undefined){
					this.props.getInfo(this.props.donor[0].donor.id);
				}
				
				this.setState({show:false})
			}
		})
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Actualizar {t('content.modal_grupo_rh.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
		        				<span>Grupo</span>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<select className="form-control" name="person_group" value={this.state.person_group}
		        					onChange={this.handleChange}>
		        					<option value="">Seleccione...</option>
		        					<option value="A">A</option>
		        					<option value="B">B</option>
		        					<option value="AB">AB</option>
		        					<option value="O">O</option>
		        				</select>
		        			</div>

		        			<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
		        				<span>RH</span>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<select className="form-control" name="person_rh" value={this.state.person_rh}
		        					onChange={this.handleChange}>
		        					<option value="+">+</option>
		        					<option value="-">-</option>
		        				</select>
		        			</div>
		        		</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.updateGroupRh} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}

}

export default translate('translations') (ModalUpdateRh)